(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-drawer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('button.thb-secondary-buy').forEach(btn => {
        btn.addEventListener('click', () => {
            console.log('asjghgsajsa');
            const drawer = document.querySelector('.buy-drawer');
            const has_mobile_menu_drawer_open = document.querySelector('details.mobile-toggle-wrapper.active summary.mobile-toggle');
            if(has_mobile_menu_drawer_open){
                has_mobile_menu_drawer_open.click();
            }

            if (drawer) {
                console.log('drawer ',drawer);
                drawer.classList.toggle('active');
                document.querySelector('.buy-drawer-overlay').classList.toggle('active');
                document.querySelector('body').classList.toggle('open-cc');
                
            }
        });
    });

    document.querySelectorAll('.buy-drawer-overlay').forEach(item => {
        item.addEventListener('click', () => {
            const drawer = document.querySelector('.buy-drawer');
            if (drawer) {
                drawer.classList.remove('active');
                document.querySelector('.buy-drawer-overlay').classList.remove('active');
                document.querySelector('body').classList.remove('open-cc');
            }
        });
    });

    document.body.addEventListener('click', function (e) {
    if (!e.target.closest('.thb-header-right .thb-secondary-buy') && !e.target.closest('.side-panel.buy-drawer')) {
        
        const drawer = document.querySelector('.buy-drawer');
        if (drawer) {
            drawer.classList.remove('active');
            document.querySelector('.buy-drawer-overlay').classList.remove('active');
            document.querySelector('body').classList.remove('open-cc');
        }
    }
    });
  } catch(e) { console.error(e); }
})();

})();
